<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="500px"
            @keydown.esc="close"
  >
    <v-card>
      <div class="add_fa" style="height: 270px">
        <button class="close_bt" @click="close"></button>
        <span class="s_pop_title" style="font-size: 17pt; margin-bottom: 20px">{{ editCorp.corpTitile }}</span>
        <input 
            solo
            placeholder="대그룹"
            v-model="editCorp.editCorpName"
            v-on:keyup.enter="createBookmark()">
        <div class="btnArea">
          <button type="submit" class="btn type3" @click="addCorp()">저장</button>
          <button type="submit" class="btn type3 reset" @click="close()">취소</button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';
export default {
  components: {
  },
  props: [
    'dialog',
    'editCorp',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
    };
  },
  mounted () {
    this.loading = false;
  },
  methods: {
    init () {
    },
    async addCorp () {
      /* 회사추가팝업 > 추가 */
      let corpName = this.editCorp.editCorpName;

      let params = { corpName: corpName, _id: this.editCorp._id };
      if (this.editCorp.type === 'edit') {
        await this.$http.post('/api/v1/company/editCorp', params).then(response => {
          console.log(response);
          if (response.status === 200) {
            Util.snackBarOpen(this.$t('회사 정보가 적용되었습니다.'), 'primary');
            this.init();
            this.closeDialog();
            this.companyList = [];
  
          }
        }).catch(error => {
          console.log(error);
        });
      } else {
        await this.$http.post('/api/v1/company/addCorp', params).then(response => {
          console.log(response);
          if (response.status === 200) {
            Util.snackBarOpen(this.$t('회사 정보가 적용되었습니다.'), 'primary');
            this.init();
            this.closeDialog();
            this.companyList = [];
  
          }
        }).catch(error => {
          console.log(error);
        });
      }

    },
    close () {
      this.closeDialog();
    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/popup/CorpCreateDialog.vue